import { render, staticRenderFns } from "./ContractDetails.vue?vue&type=template&id=10b55ec2&"
import script from "./ContractDetails.vue?vue&type=script&lang=ts&"
export * from "./ContractDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports